import React from 'react';
import { connect } from 'react-redux';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import PictureUpload from '../../components/CustomUpload/PictureUpload';
import map from 'lodash/map';

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import { withStyles, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Chip, InputAdornment, Icon } from '@material-ui/core';
import defaultUserImage from "assets/img/no_profile.png";
import DataTable from '../../components/Table/DataTable';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faPencil } from '@fortawesome/pro-solid-svg-icons';

import { CircularProgress } from "@material-ui/core";
import Api from '../../api/Api.js';
import SystemEndpoints from '../../api/SystemEndpoints';

class SystemDetail extends React.Component {

    state = {
        editUser: false,
        editingUser: null,
        openCredentials: '',

        saveCredentialChanges: {}
    }

    options = {
        onRowClick: (row, { dataIndex, rowIndex }) => this.setState({ editUser: true, editingUser: this.props.users[dataIndex] })
    };

    displayProviderChip(provider) {

        if (!this.state.editingUser)
            return null;

        var providerIndex = this.state.editingUser.auth_credentials.findIndex(x => x.provider_name === provider.provider);
        var providerCredentials = this.state.editingUser.auth_credentials[providerIndex];
        var currentSaveCredentialChanges = this.state.saveCredentialChanges;

        const setStateOfProviderCredentails = (param, value) => {
            var new_auth_credentials = this.state.editingUser.auth_credentials;

            var defaults = {
                provider_name: provider.provider,
                auth_id: this.state.editingUser.id
            }

            new_auth_credentials[providerIndex] = {
                ...defaults,
                ...new_auth_credentials[providerIndex],
                [param]: value
            };

            currentSaveCredentialChanges[`${provider.provider}-${this.state.editingUser.id}`] = new_auth_credentials[providerIndex];

            this.setState({
                editingUser: {
                    ...this.state.editingUser,
                    auth_credentials: new_auth_credentials
                },
                saveCredentialChanges: currentSaveCredentialChanges
            })
        }

        const renderSetCredentials = () => {
            if (provider.credential_definition) {
                const credential_definition = JSON.parse(provider.credential_definition);
                return (
                    <>
                        {
                            credential_definition.username ?
                                <CustomInput
                                    labelText={(providerCredentials.username ? "Email/Username" : "Invalid Email/Username")}
                                    id="email"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        onChange: (event) => setStateOfProviderCredentails("username", event.target.value),
                                        value: providerCredentials.username
                                    }}
                                    error={!providerCredentials.username}
                                />
                                : null
                        }
                        {
                            credential_definition.password ?
                                <CustomInput
                                    labelText={("Password")}
                                    id="password"
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        type: "password",
                                        onChange: (event) => setStateOfProviderCredentails("password", event.target.value),
                                        value: providerCredentials.password,
                                        autoComplete: "new-password"
                                    }}
                                />
                                : null
                        }
                        {
                            credential_definition.other_credentials.type === "flat" ?
                                <CustomInput
                                    labelText={credential_definition.other_credentials.display}
                                    id="other_credentials"
                                    formControlProps={{ fullWidth: true }}
                                    inputProps={{
                                        type: credential_definition.other_credentials.encrypt ? "password" : "text",
                                        onChange: (event) => setStateOfProviderCredentails("other_credentials", event.target.value),
                                        value: providerCredentials.other_credentials,
                                        ...(credential_definition.other_credentials.encrypt ? { autoComplete: "new-password" } : {}),
                                    }}
                                />
                                : null
                        }

                    </>
                );
            } else {
                return (
                    <>
                        <CustomInput
                            labelText={(providerCredentials.username ? "Email/Username" : "Invalid Email/Username")}
                            id="email"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                onChange: (event) => setStateOfProviderCredentails("username", event.target.value),
                                value: providerCredentials.username
                            }}
                            error={!providerCredentials.username}
                        />
                        <CustomInput
                            labelText={("Password")}
                            id="password"
                            formControlProps={{
                                fullWidth: true
                            }}
                            inputProps={{
                                type: "password",
                                onChange: (event) => setStateOfProviderCredentails("password", event.target.value),
                                value: providerCredentials.password,
                                autoComplete: "new-password"
                            }}
                        />
                    </>
                );
            }
        }

        if (providerCredentials) {
            if (this.state.openCredentials !== provider.provider) {
                return (
                    <Chip
                        avatar={<FontAwesomeIcon icon={faPencil} style={{ marginLeft: 10 }} />}
                        label={'Username: ' + providerCredentials.username}
                        onClick={() => this.setState({ openCredentials: provider.provider })}
                    />
                )
            }
            else {
                return renderSetCredentials();
            }
        } else {
            if (this.state.openCredentials !== provider.provider) {
                return (
                    <Chip
                        avatar={<FontAwesomeIcon icon={faPencil} style={{ marginLeft: 10 }} />}
                        label={'Credentails Not Set'}
                        onClick={() => this.setState({ openCredentials: provider.provider })}
                    />
                );
            } else {
                providerCredentials = {};
                return renderSetCredentials();
            }
        }
        // onClick -> Set Credential

    }

    render() {
        const { classes } = this.props;
        return (
            <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                    <Card profile>
                        <div style={{ position: "relative" }}>
                            <CardAvatar style={{ height: 130, width: 130 }} profile>
                                {/* <PictureUpload
                                    style={{ height: 130, width: 130 }}
                                    imgStyle={{ height: 122, width: 122 }}
                                    preview={this.props.system.image ? ("/api/image/get?id=" + this.props.system.image) : defaultUserImage}
                                //onImagePicked={(file) => this.changeAccountPicture(file)}
                                /> */}
                                <img style={{ height: 130, width: 130, borderRadius: 75, overflow: 'hidden' }} src={this.props.system.image ? ("/api/image/get?id=" + this.props.system.image) : defaultUserImage} />
                            </CardAvatar>
                        </div>
                        <CardBody profile>
                            <h3 className={classes.cardTitle} style={{ paddingBottom: 18 }}>{this.props.system.display_name}</h3>
                            <a href="https://mobiserv.co.za">mobiserv.co.za</a>
                            {/* <h4 className={classes.cardTitle} style={{ paddingBottom: 12 }}>{this.state.customer.name}</h4> */}
                        </CardBody>
                        {/* 
                        <ExpansionPanel style={{ boxShadow: 'none', borderRadius: 8, border: 'none', borderTop: 'none', "::before": { content: 'none', display: 'none' } }} expanded={this.state.moreInfoExpanded} onChange={() => this.setState({ moreInfoExpanded: !this.state.moreInfoExpanded })}>
                            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} >
                                More Info
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <GridContainer>
                                    <GridItem xs={6} style={{ textAlign: 'left', fontWeight: 'bold' }}>
                                        Signed Up
                                    </GridItem>
                                    <GridItem xs={6} style={{ textAlign: 'right' }}>
                                        {this.state.customer.signup_date ? moment(this.state.customer.signup_date).format("YYYY-MM-DD") : "Unknown"}
                                    </GridItem>
                                </GridContainer>
                            </ExpansionPanelDetails>
                        </ExpansionPanel> 
                        */}
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={8} style={{ position: 'relative' }}>
                    <DataTable
                        title={"Users"}
                        data={this.props.users.map(user => [user.id, user.username || user.unique_identifier || user.email, user.last_login])}
                        columns={userColumns}
                        options={this.options}
                    />
                    <Dialog
                        open={this.state.editUser}
                        onClose={() => this.setState({ editUser: false, saveCredentialChanges: {} })}
                        fullWidth
                        maxWidth="sm"
                        aria-labelledby="form-dialog-title"
                    >
                        <DialogTitle id="form-dialog-title">Set Credentails</DialogTitle>
                        <DialogContent style={{ overflow: 'visible' }}>
                            {/* {JSON.stringify(this.state.editingUser)} */}
                            {
                                this.props.providers.map(provider => (
                                    <div>
                                        <h4>{provider.display}</h4>
                                        <br />
                                        {this.displayProviderChip(provider)}
                                        <br />
                                    </div>
                                ))
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button style={{ marginRight: 'auto' }} round onClick={() => this.setState({ editUser: false, saveCredentialChanges: {}, openCredentials: '' })} color="rose" simple>
                                Cancel
                            </Button>
                            {
                                this.state.loading ?
                                    <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                                    :
                                    <Button
                                        onClick={() => {
                                            console.log(this.state);
                                            this.setState({ loading: true }, async () => {
                                                var allPromises = map(
                                                    this.state.saveCredentialChanges,
                                                    (newCredential) => Api.post(SystemEndpoints.setCredentials, newCredential)
                                                );

                                                try {
                                                    await Promise.all(allPromises);
                                                    this.setState({ loading: false, editUser: false, saveCredentialChanges: {}, openCredentials: '' })
                                                } catch (e) {
                                                    console.error(e);
                                                    this.setState({ loading: false });
                                                }
                                            })
                                        }}
                                        color="rose"
                                        round
                                    >
                                        Save Credentials
                                        &nbsp;&nbsp;
                                        <FontAwesomeIcon icon={faCheck} />
                                    </Button>
                            }
                        </DialogActions>
                    </Dialog>
                </GridItem>
            </GridContainer>
        )
    }
}

const userColumns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Username/Email",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Last Login",
        options: {
            filter: false,
            sort: true,
            customBodyRender: (value, tableMeta, updateValue) => value ? moment(value).format('YYYY-MM-DD HH:mm') : "Never Logged In",
            sortDirection: 'desc'
        }
    }
];

const mapStateToProps = (state) => ({
    ...state,
    customers: state.customers.list,
    system: state.systems.mobiserv.system,
    users: state.systems.mobiserv.users,
    providers: state.systems.providers,
})

export default withStyles(userProfileStyles)(connect(mapStateToProps)(SystemDetail));